import { createUseStyles } from 'react-jss';

const styles = createUseStyles(() => ({
  textRight: {
    textAlign: 'right',
  },
}));

export default styles;
